import colors from "../../../../appConfig/colors";
import { makeStyles } from "@material-ui/core/styles";

// Medias
import home_banner from "../../../../../assets/images/home_banner.png";

const AssessmentStyle = makeStyles((theme) => ({
	rootContainer: {
		height: "80vh",
		[theme.breakpoints.down("sm")]: {
			height: "auto",
			padding: theme.spacing(2),
		},
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		background: `linear-gradient(135deg, ${colors.darkRose}, ${colors.charcoalTint})`,
		position: "relative",
	},
	paper: {
		width: "85%",
		maxWidth: 1200,
		height: 550,
		display: "flex",
		[theme.breakpoints.down("sm")]: {
			flexDirection: "column",
			height: "auto",
			paddingBottom: theme.spacing(2),
			marginTop: "10px",
		},
		overflow: "hidden",
		borderRadius: 16,
		boxShadow: `0 8px 30px ${colors.shadowAlpha33}`,
		backgroundColor: colors.white,
		marginTop: "-60px",
		marginBottom: "60px",
	},
	leftPanel: {
		backgroundColor: colors.ashGray,
		color: colors.white,
		width: "35%",
		[theme.breakpoints.down("sm")]: {
			width: "100%",
			padding: theme.spacing(3),
			alignItems: "center",
			justifyContent: "flex-start",
			overflow: "hidden",
		},
		display: "flex",
		flexDirection: "column",
		alignItems: "flex-start",
		justifyContent: "center",
		padding: theme.spacing(6),
		position: "relative",
	},
	rightPanel: {
		width: "65%",
		[theme.breakpoints.down("sm")]: {
			width: "100%",
			padding: theme.spacing(3),
			textAlign: "center",
		},
		background: colors.whiteSmoke,
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		padding: theme.spacing(3),
		textAlign: "center",
		overflow: "scroll",
	},
	title: {
		fontWeight: 700,
		fontSize: "1.75rem",
		[theme.breakpoints.down("sm")]: {
			fontSize: "1.4rem",
			textAlign: "center",
			marginTop: theme.spacing(1),
		},
		lineHeight: 0.8,
		marginBottom: theme.spacing(2),
	},
	divider: {
		width: "60px",
		height: "4px",
		backgroundColor: colors.primary,
		margin: `${theme.spacing(1)}px 0`,
		borderRadius: 2,
	},
	button: {
		marginRight: "10px",
		marginTop: theme.spacing(4),
		backgroundColor: colors.primary,
		width: "250px",
		[theme.breakpoints.down("sm")]: {
			width: "100%",
			padding: "12px 16px",
			marginRight: 0,
		},
		color: colors.white,
		fontWeight: 600,
		padding: "12px 32px",
		borderRadius: 8,
		textTransform: "none",
		boxShadow: `0 4px 12px ${colors.mutedCrimson}`,
		transition: "all 0.3s ease",
		"&:hover": {
			backgroundColor: colors.darkCrimsonRed,
		},
	},
	secondaryButton: {
		marginLeft: "10px",
		marginTop: theme.spacing(4),
		borderColor: colors.primary,
		color: colors.primary,
		width: "250px",
		[theme.breakpoints.down("sm")]: {
			width: "100%",
			marginLeft: 0,
			marginTop: theme.spacing(2),
		},
		fontWeight: 600,
		padding: "10px 28px",
		borderRadius: 8,
		textTransform: "none",
		transition: "background 0.3s, box-shadow 0.3s",
		"&:hover": {
			backgroundColor: colors.blushPink,
			boxShadow: `0 4px 10px ${colors.primaryFaintShadow}`,
		},
	},
	descriptionBox: {
		padding: "20px 24px",
		borderRadius: 12,
		maxHeight: 450,
		textAlign: "justify",
		color: colors.black,
		[theme.breakpoints.down("sm")]: {
			maxHeight: "none",
			padding: "12px 8px",
			textAlign: "left",
		},
	},
	buttonsContainer: {
		display: "flex",
		marginTop: "-15px",
		[theme.breakpoints.down("sm")]: {
			flexDirection: "column",
			alignItems: "stretch",
			marginTop: theme.spacing(1),
		},
	},
	subText: {
		color: colors.neutralDarkGray,
		maxWidth: 400,
		[theme.breakpoints.down("sm")]: {
			maxWidth: "100%",
			fontSize: "0.95rem",
		},
		fontSize: "1rem",
		marginTop: theme.spacing(2),
		lineHeight: 1.6,
	},
	reflectionContainer: {
		position: "relative",
		width: 300,
		maxWidth: "100%",
		margin: "0 auto",
		"@media (max-width:600px)": {
			width: "100%",
		},
	},
	imageContainer: {
		padding: "40px 20px 20px 20px",
		textAlign: "center",
		width: "100%",
		[theme.breakpoints.down("md")]: {
			width: "100%",
			padding: "0px",
			textAlign: "center",
		},
		[theme.breakpoints.down("sm")]: {
			width: "70%",
			padding: "40px 20px 20px 20px",
			textAlign: "center",
		},
	},
	image: {
		width: "90%",
		maxWidth: "100%",
		display: "block",
		[theme.breakpoints.down("md")]: {
			// width: "70%",
			// maxWidth: "70%",
			// display: "block",
		},
		[theme.breakpoints.down("sm")]: {
			width: "90%",
			maxWidth: "100%",
			display: "block",
		},
	},
	reflection: {
		position: "absolute",
		top: "100%",
		left: 0,
		width: "100%",
		height: "100%",
		backgroundSize: "cover",
		backgroundRepeat: "no-repeat",
		transform: "scaleY(-1)",
		opacity: 1,
		filter: "blur(0px)",
		maskImage: `linear-gradient(to bottom, ${colors.darkShadowAlpha99}, transparent)`,
		WebkitMaskImage: `linear-gradient(to bottom, ${colors.fullBlackAlpha}, transparent)`,
		backgroundImage: `url(${home_banner})`,
	},
	lightLoader: {
		color: `${colors.primary} !important`,
	},
	darkLoader: {
		color: colors.primary,
	},
	headerLineTest_1: {
		width: "100%",
		marginTop: "40px",
	},
	headerLineTest_2: {
		width: "100%",
	},
	headerLineTest_3: {
		width: "100%",
	},
	headerLineTest_4: {
		color: colors.charcoalGray,
		fontWeight: 700,
	},
	bodyTest: {
		lineHeight: 1.6,
		fontSize: "0.9rem",
	},
}));

export default AssessmentStyle;
